import { FormBuilderItemMap, FormItemType } from '../constants/form-builder.constants'

export const builderComponentFactory = (itemType: FormItemType): any => {
  return FormBuilderItemMap[itemType]
}
